export class InvoiceLineItemsSummary
{
    totalLines: number;
    materialLines: number;
    laborLines: number;
    otherLines: number;
    totalQty: number;
	materialQty: number;
	laborQty: number;
	otherQty: number;
    totalCost: number;
    materialCost: number;
    laborCost: number;
    otherCost: number;
    totalPrice: number;
    materialPrice: number;
    laborPrice: number;
    otherPrice: number;
    totalAmount: number;
    totalTax: number;
    total: number;
}
